import suitcaseSrc from '@svgs/global/Briefcase.svg?url';
import calendarSrc from '@svgs/global/Calendar.svg?url';
import chartSrc from '@svgs/global/Chart.svg?url';
import coinsInHandSrc from '@svgs/global/CoinsInHand.svg?url';
import computerSrc from '@svgs/global/Computer.svg?url';
import dollarSrc from '@svgs/global/Dollar.svg?url';
import handshakeSrc from '@svgs/global/Handshake.svg?url';
import palmSrc from '@svgs/global/PalmTree_bone.svg?url';
export var careerBenefitsSectionContent = {
    benefits: [
        {
            title: 'Vacation Time Off',
            description: "\n        We love to vacation, and most roles will be offered paid vacation time within\n        your first 90 days. Plus we offer 8 paid holidays, bereavement leave, and sick time.\n      ",
            type: 'career',
            svgSrc: palmSrc,
        },
        {
            title: 'Paid Parental Leave',
            description: "\n        Upon meeting the required tenure, receive 12 weeks of paid parental leave when\n        you welcome a new (human) family member.\n      ",
            type: 'career',
            svgSrc: computerSrc,
        },
        {
            title: 'Employee Discounts',
            description: "\n        All employees get steep, steeeeep discounts on our food. Many switch their dogs\n        to Nom Nom because its gentler on their pets stomachs and their wallets.\n      ",
            type: 'career',
            svgSrc: dollarSrc,
        },
        {
            title: 'Full Benefits',
            description: "\n        Health, dental and vision, plus HSA/FSA and an employee assistance program. We offer a\n        comprehensive package to help keep you at your best, so you can keep dogs at their best.\n      ",
            type: 'career',
            svgSrc: suitcaseSrc,
        },
        {
            title: '401k Match',
            description: "\n        Yes, we fantasize about retirement, too. And we\u2019ll help you get there by contributing\n        towards yours every month.\n      ",
            type: 'career',
            svgSrc: coinsInHandSrc,
        },
        {
            title: 'Good Times',
            description: "\n        We like socializing. We\u2019re the type of place where everyone knows everyone\u2019s pets\u2019 names.\n        Kids\u2019 names are 50-50.\n      ",
            type: 'career',
            svgSrc: handshakeSrc,
        },
    ],
    tickerText: 'Perks & Benefits',
};
export var affiliateBenefitsSectionContent = {
    tickerText: 'AFFILIATE PROGRAM BENEFITS',
    benefits: [
        {
            title: 'Commissions on Every New Customer',
            type: 'affiliate',
            svgSrc: dollarSrc,
        },
        {
            title: '30-day Cookie Window',
            type: 'affiliate',
            svgSrc: calendarSrc,
        },
        {
            title: 'Real-time Tracking Through Rakuten',
            type: 'affiliate',
            svgSrc: chartSrc,
        },
        {
            title: 'Special Offers for Your Audience',
            type: 'affiliate',
            svgSrc: dollarSrc,
        },
    ],
};
